import * as Yup from "yup"
import {
    validBoolean,
    validString,
} from "Components/shared/helpers/validations"
import { reverseShape } from "Helpers/reverse-shape"

const FileSchema = Yup.object({
    fileName: validString.required(),
    fileType: validString.required(),
    base64String: validString.required(),
})

const AttachmentsSchema = Yup.object().shape(
    reverseShape({
        nric_passport:FileSchema.required(),
        acceptTerms:Yup.boolean().oneOf([true]).required(),
    })
)

export default AttachmentsSchema;